export const CREATE_CONFLUENCE_SPACE = 'CREATE_CONFLUENCE_SPACE';

export type CreateConfluenceSpaceAction = {
	type: typeof CREATE_CONFLUENCE_SPACE;
	autoCreated?: boolean;
};

export const createConfluenceSpace = (autoCreated?: boolean): CreateConfluenceSpaceAction => ({
	type: CREATE_CONFLUENCE_SPACE,
	autoCreated,
});

export const CREATE_CONFLUENCE_SPACE_ERROR = 'CREATE_CONFLUENCE_SPACE_ERROR';

export type CreateConfluenceSpaceErrorAction = {
	type: typeof CREATE_CONFLUENCE_SPACE_ERROR;
};

export const createConfluenceSpaceError = (): CreateConfluenceSpaceErrorAction => ({
	type: CREATE_CONFLUENCE_SPACE_ERROR,
});
